<template>
    <v-dialog v-model="dialog" max-width="705" :fullscreen="$vuetify.breakpoint.xs">
        <v-card class="py-8 px-11">
            <v-row justify="end" class="ma-0">
                <v-btn icon>
                    <v-icon @click="dialog = false">mdi-close</v-icon>
                </v-btn>
            </v-row>
            <h2 class="text-center">{{$t('quizzes.important')}}</h2>
            <p class="mt-6">{{$t('quizzes.confirm_message')}}</p>
            <p class="font-weight-bold mt-3">{{$t('quizzes.note')}}</p>
            <v-card-actions class="d-flex justify-center mt-7">
                <v-btn class="green white--text" width="105" @click="startQuiz">{{$t('quizzes.accept')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: ['quiz_id'],
        data(){
            return { dialog: false }
        },
        methods: {
            startQuiz() {
                this.$router.push({name: 'QuizStart', query: { quiz_id: this.quiz_id }})
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../scss/components/show";
</style>